import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { NavigationService } from 'src/app/navigation/service/navigation.service';

@Component({
    selector: 'app-chart-kpi-bar',
    templateUrl: './chart-kpi-bar.component.html',
    styleUrls: ['./chart-kpi-bar.component.scss'],
    standalone: false
})
export class ChartKpiBarComponent implements OnInit, OnChanges {
  @Input() hc: any = {};
  @Input() chartData: any;
  @Input() showFilter: boolean = false;
  @Input() filterType: string = '';
  @Input() pointWidth: number = 20;
  @Input() chartWidth: number = 0;
  @Input() filterFrom: string = '';

  columnchart: any;

  constructor(public navService: NavigationService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.columnchart = this.buildChart() ?? this.buildEmpty();
  }

  buildChart() {
    const chartData = this.chartData;

    if (!chartData) {
      return;
    }
    const categories = chartData.labels.map((label: any) =>
      label === null ? 'Unknown' : label
    );
    const data = chartData.data.map((data: any) => data);
    const yAxisLabelsFormat = data[0].name === 'Exit' ? '{value:.0f}' : '';
    return {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      xAxis: {
        categories,
        crosshair: true,
        lineColor: '#545454B8',
        labels: {
          style: {
            color: '#545454B8',
            fontWeight: '600',
            fontSize: '10px',
            fontFamily: 'Nunito',
          },
        },
      },
      yAxis: {
        lineWidth: 1,
        tickAmount: 6,
        gridLineWidth: 0,
        title: '',
        lineColor: '#545454B8',
        labels: {
          format: yAxisLabelsFormat,
          style: {
            color: '#545454B8',
            fontWeight: '600',
            fontSize: '10px',
            fontFamily: 'Nunito',
          },
        },
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          borderWidth: 0,
        },
        series: {
          pointWidth: this.pointWidth,
        },
      },
      credits: {
        enabled: false,
      },
      legend: {
        symbolRadius: 0,
        itemStyle: {
          fontFamily: 'Nunito',
          fontWeight: 600,
        },
      },
      series: data,
      // to make sure the graph is responsive at all break-points
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              yAxis: {
                labels: {
                  align: 'left',
                  x: 0,
                  y: -2,
                },
                title: {
                  text: '',
                },
              },
            },
          },
        ],
      },
    };
  }

  buildEmpty() {
    return {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: [],
        crosshair: true,
        lineColor: '#545454B8',
        labels: {
          style: {
            color: '#545454B8',
            fontWeight: '600',
            fontSize: '10px',
            fontFamily: 'Nunito',
          },
        },
        tickInterval: 1,
      },
      yAxis: {
        lineWidth: 1,
        tickAmount: 6,
        gridLineWidth: 0,
        min: 0,
        title: '',
        lineColor: '#545454B8',
        labels: {
          style: {
            color: '#545454B8',
            fontWeight: '600',
            fontSize: '10px',
            fontFamily: 'Nunito',
          },
        },
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          borderWidth: 0,
        },
        series: {
          pointWidth: this.pointWidth,
        },
      },
      credits: {
        enabled: false,
      },
      legend: {
        symbolRadius: 0,
        itemStyle: {
          fontFamily: 'Nunito',
          fontWeight: 600,
        },
      },
      series: [
        {
          data: [],
        },
      ],
      // to make sure the graph is responsive at all break-points
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              yAxis: {
                labels: {
                  align: 'left',
                  x: 0,
                  y: -2,
                },
                title: {
                  text: '',
                },
              },
            },
          },
        ],
      },
    };
  }
}
